import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { navLinks, contact } from '../../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-md transition-[background-color,border-color,box-shadow,padding] duration-200 ease-out ${scrolled ? 'border-navy/[0.07] bg-cream/90 py-2.5 shadow-header' : 'border-transparent bg-cream/60 py-4'}`} data-id="element-170" data-mp="1hhc7b6th8etc">
      <div className="mx-auto flex max-w-shell items-center justify-between px-5 lg:px-10" data-id="element-171" data-mp="17ttx3tnd57c1">
        <a href="#inicio" className="leading-none" aria-label="Andrea Báez Insurance — inicio" data-id="element-172" data-mp="1co7l3azp4c6o">
          <span className="block font-display text-[15px] font-semibold tracking-[0.16em] text-navy" data-id="element-173" data-mp="ysvoey1zcbn4">
            {contact.brandTop}
          </span>
          <span className="mt-0.5 block font-display text-[9.5px] font-medium tracking-[0.42em] text-teal" data-id="element-174" data-mp="1qhp7d3jro30e">
            {contact.brandBottom}
          </span>
        </a>

        <nav className="hidden items-center gap-7 xl:flex" aria-label="Navegación principal" data-id="element-175" data-mp="1hpwy2w6hazxe">
          {navLinks.map(l => <a key={l.href} href={l.href} className="whitespace-nowrap font-body text-[13px] font-medium text-ink/70 transition-colors duration-200 ease-out hover:text-teal" data-id="element-176" data-mp="1lq7428u9tqc9">
              {l.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-177" data-mp="2o3tbzdh40ip5">
          <LinkButton href="#agenda" className="hidden sm:inline-flex" data-id="element-178" data-mp="2o178boxcanc7">
            AGENDA UNA CITA
          </LinkButton>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="flex h-10 w-10 items-center justify-center rounded-full border border-navy/10 bg-white text-navy transition-colors duration-200 ease-out hover:border-navy/25 xl:hidden" data-id="element-179" data-mp="2f2lir9tga81x">
            {open ? <XIcon size={18} data-id="element-180" data-mp="1wc41q2hzd0we" /> : <MenuIcon size={18} data-id="element-181" data-mp="1wbkmitjpsqm2" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-182" data-mp="1rdj327idmpa2">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-t border-navy/[0.07] bg-cream xl:hidden" data-id="element-183" data-mp="1reu4i0ocnky0">
            <nav className="mx-auto flex max-w-shell flex-col px-5 py-4" aria-label="Navegación móvil" data-id="element-184" data-mp="1ca97rg61v73g">
              {navLinks.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="border-b border-navy/[0.06] py-3.5 font-display text-[15px] font-medium text-navy last:border-0" data-id="element-185" data-mp="1hadrdf298hxw">
                  {l.label}
                </a>)}
              <LinkButton href="#agenda" fullWidth size="lg" className="mt-5" onClick={() => setOpen(false)} data-id="element-186" data-mp="thnixftk8gsd">
                AGENDA UNA CITA
              </LinkButton>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}